import { useEffect, useState, type ReactNode } from "react";
import { Nav } from "./Nav";
import { Header } from "./Header";
import { TabBar } from "./TabBar";

const COLLAPSE_KEY = "catalog.nav.collapsed";

interface AppShellProps {
  children: ReactNode;
}

/**
 * Moldura do app (handoff): .app + .app__main; barras fixas (Nav, Header,
 * TabBar) FORA da area com padding (.content ja tem o padding, nao o shell).
 * Desktop (>=64rem/lg): Nav retratil + Header. Mobile (<64rem): Header +
 * TabBar inferior — o menu lateral NAO aparece (decisao do handoff).
 * Drawer/Modal montam na raiz via Radix Portal (document.body), cobrindo o
 * app inteiro — nao ha wrapper extra aqui pra isso, ja e o comportamento
 * padrao de ui/Drawer.tsx e ui/dialog.tsx.
 */
export function AppShell({ children }: AppShellProps): JSX.Element {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(COLLAPSE_KEY) === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSE_KEY, collapsed ? "1" : "0");
    } catch {
      /* ignore */
    }
  }, [collapsed]);

  return (
    <div className="app">
      <div className="hidden lg:flex">
        <Nav collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      </div>

      <div className="app__main">
        <Header />
        <main className="content">{children}</main>
        <div className="lg:hidden">
          <TabBar />
        </div>
      </div>
    </div>
  );
}
